import message from "./message";
import layer from "./layer";

export default {
  // ajax封装
  $ajax(option) {
    //用户配置option 默认配置init
    var init = {
      type: 'post',
      async: true,
      url: '',
      data: {},
      dataType: 'json',
      success: function () {
      },
      error: function () {
      },
      beforeSend: function () {
        // console.log('发送前...');
        return false;
      }
    };

    //TODO step1: 合并参数
    for (let k in option) {
      init[k] = option[k];
    }

    $.ajax({
      'url': init.url,
      'data': init.data,
      'type': init.type,
      'dataType': init.dataType,
      'async': init.async,
      'success': init.success,
      'error': init.error,
      'complete': init.complete,
      'jsonpCallback': 'jsonp' + (new Date()).valueOf().toString().substr(-4),
      'beforeSend': function () {

      },
    });
  },

  wxShare() {
    const url = 'https://p.xinwen.cn/api/wechat/sign?url=' + encodeURIComponent(location.href)

    $.ajax({
      url: url,
      type: 'GET',
      success: function (json) {
        wx.config({
          appId: json.appid,
          timestamp: json.timestamp,
          nonceStr: json.nonceStr,
          signature: json.signature,
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
        })
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: '智能金融',
            desc: '金融内容的解决方案',
            link: 'http://finance.shuwen.com/',
            imgUrl: 'https://s.newscdn.cn/file/2018/12/cf9b8c0c-a2e5-40a3-b89d-75304f6a7e8f.png',
            type: '',
            dataUrl: '',
            success: function () {
            }
          });
          wx.onMenuShareTimeline({
            title: '智能金融',
            link: 'http://finance.shuwen.com/',
            imgUrl: 'https://s.newscdn.cn/file/2018/12/cf9b8c0c-a2e5-40a3-b89d-75304f6a7e8f.png', // 分享图标
            success: function () {
            }
          })
        })
      }
    })


    // fetch(url)
    //   .then(response => response.json())
    //   .then((json) => {
    //     wx.config({
    //       appId: json.appid,
    //       timestamp: json.timestamp,
    //       nonceStr: json.nonceStr,
    //       signature: json.signature,
    //       jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
    //     })
    //     wx.ready(function () {
    //       wx.onMenuShareAppMessage({
    //         title: 'MAGIC智能生产平台',
    //         desc: 'MAGIC一下，做短视频更AI',
    //         link: 'http://magic.shuwen.com/',
    //         imgUrl: 'https://s.newscdn.cn/file/2018/12/cf9b8c0c-a2e5-40a3-b89d-75304f6a7e8f.png',
    //         type: '',
    //         dataUrl: '',
    //         success: function () {
    //         }
    //       });
    //       wx.onMenuShareTimeline({
    //         title: 'MAGIC智能生产平台',
    //         link: 'http://magic.shuwen.com/',
    //         imgUrl: 'https://s.newscdn.cn/file/2018/12/cf9b8c0c-a2e5-40a3-b89d-75304f6a7e8f.png', // 分享图标
    //         success: function () {
    //         }
    //       })
    //     })
    //   })
  }
}



// WEBPACK FOOTER //
// ./src/pages/finance/utils.js